export default () => {
	return {
		// 全局注入$t函数
		globalInjection: true,
		// 是否兼容旧版本i18n
		legacy: false,
		// 未匹配到语言文本时警告
		missingWarn: false
	};
};
